"use client";

import { cn } from "@/lib/utils";
import { WHATSAPP_SECTIONS, WHATSAPP_TAGS } from "@/@core/enums/whatsapp_tags.enum";
import useWhatsappContext from "@/hooks/useWhatsappContext";
import useGetWpHref from "@/hooks/useGetWpHref";
import WhatsappLinkWithBeacon from "./WhatsappLinkWithBeacon";
import { Container } from "@/components/ui/container";
import { useTranslation } from "@/hooks/translationContext";

interface Props {
  className: string;
  venue: Venue.List | Venue.Detail;
  phoneNumber: string;
  children: any;
  section: WHATSAPP_SECTIONS;
  tag?: WHATSAPP_TAGS;
  variant?: any;
  disabled?: boolean;
  translateValues?: WhatsappCustomValues;
}

export default function WhatsappButton(props: Props) {
  const { t } = useTranslation();
  const whatsappTags = useWhatsappContext();
  const getWhatsappHrefUrl = useGetWpHref();

  const { className, tag, venue, phoneNumber, children, variant } = props;

  const context = whatsappTags.getContext({
    venue: venue?.descriptions?.[0]?.title,
    ...props.translateValues,
  });

  return (
    <WhatsappLinkWithBeacon
      title={t("venue-detail-contact-button-title", {
        venue: venue?.descriptions?.[0]?.title,
      })}
      section={props.section}
      venueId={props.venue?.id}
      disabled={!phoneNumber || props.disabled}
      href={getWhatsappHrefUrl({
        phone: props.phoneNumber,
        tag: tag,
        translateValues: context,
      })}
    >
      <Container
        disabled={!phoneNumber || props.disabled}
        className={cn(
          className,
          "disabled:opacity-30 disabled:cursor-not-allowed !transition-none",
        )}
        variant={variant ? variant : "assistant"}
      >
        {children}
      </Container>
    </WhatsappLinkWithBeacon>
  );
}
